import { render, staticRenderFns } from "./c-cascader-department-member.vue?vue&type=template&id=74c097e0&scoped=true"
import script from "./c-cascader-department-member.vue?vue&type=script&lang=js"
export * from "./c-cascader-department-member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c097e0",
  null
  
)

export default component.exports